import { useBaseSelectContext } from '~/components/granular';

export function NoData() {
  const { noDataLabel } = useBaseSelectContext();
  return (
    <div className="body-200-light w-full border-b border-neutral-200 px-4 py-3 text-neutral-1000">{noDataLabel}</div>
  );
}
